<ng-content *ngIf="!hasErrors"></ng-content>